const xValueStyle = "font-family: Public Sans, system-ui, -apple-system, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, Liberation Sans, sans-serif;" +
        "font-style: normal; font-weight: bolder; font-size: 16px; color: #000000; white-space: nowrap; padding-right: 5px;";

const xValueUnitsStyle = "font-family: Public Sans, system-ui, -apple-system, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, Liberation Sans, sans-serif;" +
        "font-style: normal; font-size: 16px; color: #000000; white-space: nowrap";

const ratingStyle = "font-family: Public Sans, system-ui, -apple-system, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, Liberation Sans, sans-serif;" +
        "font-style: normal; font-weight: bolder; font-size: 16px; color: {{BORDER_LEFT_COLOUR}}; white-space: nowrap";

const yValueStyle = "font-family: Public Sans, system-ui, -apple-system, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, Liberation Sans, sans-serif;" +
		"font-style: normal; font-weight : bold;font-size: 12px; color: black; white-space: nowrap";

const boxShadow = "box-shadow: 1px 1px 1px #9c9c9c;";

const verticalDivider = "border-left: 1px solid #CDD3D6; width: 0px; height: 50px; margin-top: auto; margin-bottom: auto;";


const googleChartsTooltipHtml = 
`<div style='width : fit-content; height: 60px; display: flex; flex-direction: row; align-items: flex-start; gap: 3px; border-left: 0.375rem solid {{BORDER_LEFT_COLOUR}};border-radius: var(--bs-border-radius) !important;align-self:end'>` +
    `<div style='min-width: 100px; display: flex; flex-direction: column; align-items: center; align-self: end; justify-content: space-around; padding: 2px'>` +
        `<div style='padding-left: 5px; flex: 1 0 auto; align-self: start;'><span style='${ratingStyle}'>{{RATING}}</span></div>` + 
        `<div style='padding-left: 5px; flex: 1 0 auto; align-self: start;justify-self: flex-end;'><span style='${xValueStyle}'>{{X_VALUE}}</span><span style='${xValueUnitsStyle}'>{{X_VALUE_UNITS}}</span></div>` + 
    `</div>` +
    `<div style='${verticalDivider}'></div>` +
    `<div style='padding: 5px; flex: 1 0 auto; align-self: end;'><span style='${yValueStyle}'>{{Y_VALUE}}</span></div>` +
`</div>`;
   



const formatTooltipHtml = (xValue: string = "", xValueUnits: string = "", yValue: string = "", rating: string = "", borderLeftColour: string = "#002664") => {
    return googleChartsTooltipHtml.replaceAll("{{BORDER_LEFT_COLOUR}}", borderLeftColour)
        .replaceAll('{{RATING}}', rating)
        .replaceAll('{{X_VALUE_UNITS}}', xValueUnits)
        .replaceAll('{{X_VALUE}}', xValue)
        .replaceAll('{{Y_VALUE}}', yValue);
}

const googleChartsTooltipHtml2 = 
`<div style='width: fit-content; min-width:170px; height: 50px; display: flex; flex-direction: row; align-items: flex-start; gap: 3px; border-left: 0.375rem solid {{BORDER_LEFT_COLOUR}};border-radius: var(--bs-border-radius) !important;'>` +           
    `<div style='padding-left: 10px; flex: 1 0 auto; align-self: center;border-right :2px solid #CDD3D6;''><span style='${xValueStyle}'>{{X_VALUE}}</span></div>` +     
    `<div style='padding-left: 10px;flex: 1 0 auto; align-self: center;'><span style='${yValueStyle}'>{{Y_VALUE}}</span></div>` +
`</div>`;


const formatTooltipHtml2 = (xValue: string = "", yValue: string = "",  borderLeftColour: string = "#002664") => {
    return googleChartsTooltipHtml2.replaceAll("{{BORDER_LEFT_COLOUR}}", borderLeftColour)
        .replaceAll('{{X_VALUE}}', xValue)
        .replaceAll('{{Y_VALUE}}', yValue);
}
export { xValueStyle, yValueStyle, boxShadow, googleChartsTooltipHtml, formatTooltipHtml, formatTooltipHtml2, googleChartsTooltipHtml2 };

